import { useStorageState } from 'hooks/useStorageState';

const ORIGIN_SOURCE = 'nofomo-origin-source';

export type OriginSource = { source: string; category: string };
export const useOriginSource = () => {
  const [origin, setOrigin, { removeItem }] = useStorageState<OriginSource>(
    ORIGIN_SOURCE,
    {
      defaultValue: { source: '', category: '' },
      storageSync: false,
      engine: 'sessionStorage',
    },
  );

  return {
    origin: {
      originSource: origin.source,
      originSourceCategory: origin.category,
    },
    setOrigin,
    removeItem,
  };
};
